export default __webpack_public_path__ + "static/media/pw-template-empty-unit.3b63efa5.jpg";